export const getIatasByServices = (services, segments) => {
    const iataSet = new Set();
    services.forEach(service => {
        service.allowedSegments.forEach(allowedSegments => {
            allowedSegments.forEach(segmentId => {
                const segment = segments.find(segment => segment.segment.id === segmentId);
                if (segment) {
                    iataSet.add(segment.segment.departure.airport.iata);
                    iataSet.add(segment.segment.arrival.airport.iata);
                }
            });
        });
    });
    return [...iataSet];
};
